import { footerIcons } from "@/components/microsite/footerIcons";
import {
  autoLinksPrefix,
  autoLinksValidations,
} from "@/components/microsite/links";
import { useComponent } from "@/hooks/useMicrositeComponent";
import { useAPI } from "@/lib/api";
import { checkIsDark } from "@/lib/color";
import { cn } from "@/lib/utils";
import {
  IMicrositeComponent,
  MComponentHorizontalLink,
} from "@/types/microsite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useMemo } from "react";

const LinkComponent = ({ buttonStyle, buttonColor, ...props }) => {
  const style = useMemo(() => {
    const style: any = props?.style || {};
    if (buttonColor) {
      style.backgroundColor = buttonColor;
      style.color = checkIsDark(buttonColor || "#fff") ? "#fff" : "#333";
    }
    return style;
  }, [props.style, buttonColor]);

  return (
    <a
      {...props}
      className={cn(
        "",
        "p-1 mx-1 opacity-50 hover:opacity-100 transition-all duration-200",
        "w-11 h-11 rounded-md flex items-center justify-center opacity-100",
        "hover:brightness-125",
        buttonStyle === "circle" || buttonStyle === "square"
          ? "bg-[rgb(var(--link-background))] text-[rgb(var(--link-color))]"
          : "",
        buttonStyle === "circle" && "rounded-full",
        buttonStyle === "square" && "rounded-md"
      )}
      style={style}
    />
  );
};

const HorizontalLinkComponent = {
  kind: "HORIZONTAL_LINK",
  Render: ({ isBuilder, id, data: { backgroundColor, links, style } }) => {
    const api = useAPI();
    const { focusTo } = useComponent();
    const track = (e, type) => {
      if (isBuilder) {
        e.preventDefault();
        focusTo(id || "");
      }

      const post = {
        component_id: id,
        action_type: "link-" + type,
      };
      api.post("/track/microsite", post).then(() => {
        //...
      });
    };

    const getURL = (item) => {
      const validate = autoLinksValidations[item.icon];
      if (validate && validate(item.url)) {
        const prefix = autoLinksPrefix[item.icon];
        if (prefix) {
          return prefix + item.url;
        }
      }
      return item.url;
    };

    return (
      <div
        id={isBuilder ? `mcomp-${id}` : undefined}
        className="flex justify-center p-2 my-2 w-full"
      >
        {links?.map((item, index) => {
          if (!footerIcons[item.icon]) return <Fragment key={index} />;
          if (!item.url) return <Fragment key={index} />;
          return (
            <LinkComponent
              key={index}
              href={getURL(item)}
              target="_blank"
              rel="noopener noreferrer"
              buttonStyle={style}
              buttonColor={backgroundColor}
              onClick={(e) => track(e, item.icon)}
            >
              <FontAwesomeIcon
                icon={footerIcons[item.icon]}
                className="w-6 h-6 text-2xl"
              />
            </LinkComponent>
          );
        })}
      </div>
    );
  },
} as IMicrositeComponent<MComponentHorizontalLink>;

export default HorizontalLinkComponent;
